export const zh = {
  'header': {
    'premium': '首頁',
    'about_us': '關於我們',
    'blog': '兩性專欄',
    'consultation': '服務介紹',
    'alert_button': '前往新官網'
  },
  'banner': {
    'title': '正式加入亞洲最大約會集團',
  },
  'story': {
    'title': '找對象，你需要專業的陪伴',
    'text': '經歷結婚、離婚、再婚，最後才找到屬於自己的理想生活。看著身邊單身朋友在感情路上一直遇到不合適的人。為了這些好朋友，我開始努力研究出如何可以更有效率地找到合適對象。 <br> <br> 才發現找對象其實需要大量的配對數據、經驗以及配對資料庫才能達到有效率的安排相親。但也因為經歷過，所以我知道配對除了理性分析還有感性陪伴及討論。因此我也要求Aimm的姻緣規劃師都能把客戶當成朋友，陪他們經歷這一路上尋找幸福的過程。<br> <br> 請讓我們一起努力找到屬於你的幸福',
    'aimm_founder': 'Aimm 創辦人',
    'about_Ti': 'Tilaine / 時尚媒人',
    'profile1': '美國媒人協會 Matchmaking Institue 認證媒人',
    'profile2': '紐約大學 New York University 口語傳播碩士',
    'profile3': 'GQ、關鍵評論網、遠見專欄作家'
  },
  'price': {
    'title': '專注在配對',
    'basic_title': '專業方案',
    'advanced_title': '獨家方案',
    'prestigious_title': '尊榮方案',
    'basic_slogan': '深度諮詢了解你的需求<br />過濾不合適的對象',
    'advanced_slogan': '對方檔案看完後<br />才出來見面',
    'prestigious_slogan': '與姻緣規劃師一起挑選<br />適合你的配對對象',
    'basic_info1': '六個月三次約會',
    'basic_info2': '打造個人檔案',
    'basic_info3': '直接安排(視訊)見面',
    'basic_info4': '保證約會對象符合設定條件',
    'advanced_info1': '六個月三次約會',
    'advanced_info2': '打造個人檔案',
    'advanced_info3': '直接安排(視訊)見面',
    'advanced_info4': '看完對方檔案後同意才安排見面',
    'prestigious_info1': '六個月三次約會',
    'prestigious_info2': '打造個人檔案',
    'prestigious_info3': '直接安排（視訊）見面',
    'prestigious_info4': '資料庫自行挑選心儀對象配對',
    'elite_title': '一般會員',
    'elite_info': '加入配對資料庫',
    'elite_btn': '加入會員',
    'elite_text1': '打造個人檔案',
    'elite_text2': '接受全系統配對邀請',
    'elite_text3': '直接安排(視訊)見面',
    'consultation_btn': '預約免費諮詢',
    'currency_tw': '台幣',
    'currency_us': '美金',
    'bilingual': '＊雙語服務另計'
  },
  'status': {
    'title': '姻緣工程',
    'subtitle': '服務特色',
    'database': '配對資料庫',
    'person': '人',
    'male_age': '男生 25-50歲',
    'female_age': '女生 25-45歲',
    'country_text': '專業認證媒人服務<br>見面後配對成功率',
    'language_text': '用戶能使用中文<br>75%為雙語言 ',
    'education_text': '大專以上學歷 <br>只提供條件好的對象 ',
    'match_text': '用戶有國外求學或生活背景<br>遍及美、加、日以及歐洲等地'
  },
  'media': {
    'big_title': '媒體',
    'small_title': '報導'
  },
  'callToAction': {
    'title': '請告訴我們<br>你期望的對象條件',
    'gender': '性別',
    'age': '年齡',
    'to': '至',
    'preferLocation': '對方所在地區',
    'otherPrefer': '其他加分條件',
    'submitConsultation': '預約諮詢',
    'secondTitle': '讓我們多了解你一點',
    'firstName': '名',
    'lastName': '姓',
    'birth': '出生年',
    'myGender': '我是',
    'male': '男性',
    'female': '女性',
    'country': '國家',
    'zone': '地區',
    'communication': '通訊軟體',
    'account': '帳號',
    'country_code': '國碼',
    'phone': '聯絡電話',
    'email': '電子郵件',
    'note': '備註',
    'error': '請完成表單',
    'submit': '完成登記',
    'number_error': '請輸入阿拉伯數字',
    'cancel': '取消',
    'look_for': '想找的性別 ',
    'single': '單身從未結過婚',
    'divorce': '離婚',
    'separated': '分居',
    'widow': '喪偶',
    'marriage': '已婚',
    'email_error': '請輸入完整 Email 格式',
    'elite_title': '我想加入配對資料庫',
    'marital_status': '是否有過婚姻經驗',
    'thank': '預約完成，<br/>Aimm認真對待每個客戶，<br />將有專人盡快與你聯繫，敬請留意來電',
    'thank2': '預約完成，Aimm認真對待每個客戶，將有專人盡快與你聯繫，敬請留意來電'
  },
  'about_ti': {
    'resume1': '美國媒人協會 Matchmaking Institue 認證媒人',
    'resume2': '紐約大學 New York University 口語傳播碩士',
    'resume3': 'GQ、關鍵評論網、遠見專欄作家',
    'cofounder': 'Aimm 創辦人',
    'big_title': '時尚媒人',
    'text': '有人說，跟著感覺走，你就會遇到對的人；也有人說，當你遇到對的人，你的心會告訴你。 這些論述，是浪漫主義者的信仰，也是電影、偶像劇大力鼓吹的愛情觀念；<br /><br />然而，對 Aimm 而言，浪漫與感覺不見得是找到理想伴侶的真正關鍵。 Aimm 尊重每個人對理想生活的追求，也認為理想生活不應有所妥協。因此，我們提出「姻緣工程」系統，透過精密的分析、拆解，將你的理想生活具體呈現，協助你在茫茫人海中找到理想對象。<br /><br />Aimm 獨創的「姻緣工程」系統，以社會學、人類學及心理學為基礎，融合美國媒人學院 (Matchmaking Institute) 的專業方法與華人文化底蘊進行分析和媒合，你的理想生活，值得用更好的方式被實現。'
  },
  'match_story': {
    'title': '真實配對故事',
    'matchmaker': '規劃師',
    'meet_id': '見面ID',
    'story_title1': '為了找對象特別搬回台灣',
    'story_text1': '客戶（女37歲）在工作上一直很順利，但感情路上卻一直遇不到合適的對象。因為覺得自己的年紀大了，她甚至為此決定從中國搬回台灣。在來Aimm之前，她詢問了很多不同的婚友社。但或許是因為她的年紀及高學歷讓大部分的紅娘都要求她降低擇偶標準。但我跟她說，因為她的條件要求較高或許會花比較長的時間，但一起努力我相信一定會找到適合你的對象。後來她跟第二次排約對象順利結婚，恭喜他們！',
    'story_title2': '認真找尋想要認真交往的對象',
    'story_text2': '對於這對配對組合印象最深的就是兩個客戶（男39歲）（女35歲）不約而同在深度諮詢的時候，分別跟自己的姻緣規劃師強調自己是認真想要找認真交往的對象。兩個人一個在紐約、一個在舊金山。視訊見面後，兩人迅速地交換了聯絡方式。男生甚至在一週後馬上預定了下個長假要飛去找女生的機票。期待他們更多的好消息',
    'story_title3': '遇到對的人什麼就都對了',
    'story_text3': '我的客戶（男39歲）一整年一半的時間在加州，一半的時間在台灣是個工作很忙的專業經理人。使用尊榮方案的他，光是跟規劃師約時間挑對象都很難排時間了。讓我一度擔心就算幫他找到合適對象，他可能也沒有時間約會。安排完第一次排約後，兩邊客戶（女35歲）都相當滿意。因為兩人無論在求學經驗或家庭背景都有許多的共通點。最感動的是在交換聯絡方式後，男生客戶真的有花時間跟女生客戶多相處，目前穩定交往中。',
    'story_title4': '找到話題的神發展',
    'story_text4': '我的客戶（女34歲）在跟約會對象（男32歲）見面前很擔心因為自己年紀比對方大，會聊不來。得知客戶的疑慮後，我特別在介紹認識時，說明彼此都有在美國生活的海外經驗，藉此讓他們順利開起話題。沒想到聊沒幾句就聽見笑聲～當天男生就邀請客戶一起吃晚餐，真沒想到雙方的發展會如此神速，才剛離開咖啡廳隨即展鎧另一場約會呢！開對話題，年紀不是問題。',
    'story_title5': '早到半小時與遲到半小時的約會',
    'story_text5': '週六下午為客戶安排了約會，沒想到4點的一場大雨把所有的事情都打亂了。客戶（男32歲）因為擔心大雨路況不好，運動結束後沒有回家梳洗，4:30便穿著球衣趕到相約的咖啡廳。約會對象（女29歲）希望能給男生好的印象，特意到髮廊打理造型，卻因為下雨塞車遲到了半小時。一場大雨讓做為規劃師的我下出一身汗，但其實兩人用了不同方式表示對約會的重視，還好最後他們順利地交換了聯絡方式。',
    'story_title6': '最貼心的約會安排',
    'story_text6': '週日到台中幫客戶（女36歲）安排約會，約會對象（男37歲）跟我一樣是台北人，在安排約會的過程中，男生讓我覺得特別貼心。表示自己願意配合客戶到台中約會。同時，女生客戶也很體貼的詢問，是否直接安排在火車站周邊的地區，方便對方的交通安排。過去安排過無數的相親約會，從來沒有一對約會組合讓我有這樣窩心的感覺。果然，不出我所料，他們兩人順利交換聯絡方式，目前穩定交往中'
  },
  'footer': {
    'about_aimm': '認識我們',
    'about_us': '關於我們',
    'media': '媒體報導',
    'blog': '部落格',
    'join_us': '加入我們',
    'social_media': '社群媒體',
    'contact_us': '聯絡我們',
    'legal': '法律與隱私',
    'privacy': '隱私權及使用者條款',
    'agreement': '姻緣工程服務契約之一般性規範事項',
    'more': '更多相關',
    'facebook': 'Facebook',
    'partnership': '歡迎合作洽談',
    'copyright': 'Copyright © 2020  LA TW 姻緣工程顧問股份有限公司. 保留一切權利。'
  },
  'about': {
    'youtube_title': '一段姻緣，最美好的地方是什麼？<br/>是和理想的伴侶，共同構築理想生活。',
    'youtube_info1': '美好的姻緣是為了構築共有的理想生活。然而，人心何其複雜，每個人不同的家庭背景、社會經歷各自醞釀出不同的習慣、個性和人格；因此我們提出「姻緣工程」- 經過精密的分析、拆解、測試、比對，為你在茫茫人海當中，找到能與你共同經營夢想生活的那一個人。',
    'youtube_info2': 'Aimm 獨創的「姻緣工程」系統，以社會學、人類學及心理學為基礎，融合國際媒人機構的專業方法，與華人文化底蘊進行分析和媒合，為你找到你的最後一任女朋友。',
    'aimm': 'Aimm 的服務有什麼特別?',
    'system_title': '獨創「姻緣工程」系統',
    'system_info': '結合美國媒人學院的專業方法，以社會學、人類學及心理學為基礎發明姻緣工程，連結幸福。',
    'human_title': '專門服務全球單身華人',
    'human_info': 'Aimm 的客戶和規劃師遍佈全球，希望可以為世界各地的單身華人找到另一半',
    'heart_title': '只安排互相欣賞的',
    'heart_info': '再也別去一堆無效的排約！Aimm只安排雙方對彼此都有好感的組合見面， 每次meetup都是一段美緣！'
  },
  'story_card': {
    'title': '了解更多<br>真實配對故事'
  }
}
